














import { defineComponent } from '@nuxtjs/composition-api'
import CAlert from '~/components/shared/configurable/alert/CAlert.vue'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import { CategoryId } from '~/models/category/types'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    CAlert,
    CLink,
    CInfoModal
  },
  setup() {
    return {
      CategoryId
    }
  },
  i18n: defineComponentTranslations({
    go_to_wanted_parts: {
      en: 'Create your classified in Wanted Parts',
      el: 'Καταχώρισε την αγγελία σου στη Ζήτηση Ανταλλακτικού'
    },
    wanted_parts_description: {
      en:
        'Wanted Parts category is exclusively aimed at professionals seeking spare parts.',
      el:
        'Η κατηγορία Ζήτηση Ανταλλακτικού απευθύνεται αποκλειστικά σε επαγγελματίες που αναζητούν ανταλλακτικά.'
    }
  })
})
